import { defineStore, getActivePinia } from "pinia";
import { getModelList, queryLoraTaskProcess, addUploads, delUploads, getUploadList, createLora, updateLoraTask, cancelLoraTask, getLoraTaskState, reportSelectModel } from "@/api/api/apiLora.js"
import { firebaseUtils } from "@/utils/analytic/firebaseUtils.js";
import useCreateLayoutStore from "@/store/create/createLayoutStore.js";
import useUserDataStore from "@/store/userDataStore";
import message from "@/components/functionCallComponent/message/message.js"

const useModelData = defineStore({
    id: "modelDataStore",
    state: () => {
        return {
            model_list: [],
            lora_model_list: [],
            default_model: {},
            current_model: {},
            lora_id: 0,
            lora_state: 0,
            loraUploadList: [],
            uploadList: [], // state = 1 代表未上传成功  2 代表已经上传成功  3 代表上报成功  
            upload_ids: [],
            model_name: '',
            loraRnderData: {
                refreshing: false,
                loadingMore: false,
                isLoading: false,
                loadError: false,
                finished: false,
            },
            generating_progress: 0,
            show_modle: {},
            wait_num: 0,
            // total: 0, // 总数
            show_total: 0,
            choose_model_data: {
                show_choose_model: false,
                is_show: false
            },
            similar_mode_model: null,
            uploadControllers: {}
        }
    },
    actions: {
        addTotal() {
            this.show_total++
        },

        showChooseModelPop() {
            this.choose_model_data.is_show = true
        },

        updataChooseModelPop() {
            if (this.choose_model_data.is_show) {
                this.choose_model_data = {
                    show_choose_model: false,
                    is_show: false
                }
                reportSelectModel(
                    {
                        model: this.current_model.model
                    }
                ).then(res => {
                    if (res.code == 200) {
                    }
                })
            }
        },

        getFileNumber() {
            const result = this.uploadList.filter(item => { return [1, 2].includes(item.state) });
            return this.show_total + result.length
        },

        // 获取模型列表
        getAllModelList(data) {
            return new Promise((resolve) => {
                getModelList(
                    data
                ).then(res => {
                    if (res.code == 200) {
                        const userDataStore = useUserDataStore();
                        const { official_models, user_models, default_model, current_model } = res.data
                        this.model_list = official_models || []
                        this.lora_model_list = user_models || []
                        this.current_model = current_model || default_model || {}
                        this.lora_model_list.forEach(item => {
                            if (item.model == this.current_model.model) {
                                this.current_model = {
                                    ...this.current_model,
                                    uid: userDataStore?.userInfo?.user?.id
                                }
                            }
                        })
                        this.default_model = default_model || {}
                        if (!current_model) {
                            this.choose_model_data.show_choose_model = true
                            console.log(this.choose_model_data)
                        }
                        resolve(this.current_model)
                    }
                })
            })

        },

        refreshingModelState() {
            return new Promise((resolve) => {
                getModelList(
                ).then(res => {
                    if (res.code == 200) {
                        const userDataStore = useUserDataStore();
                        const { official_models } = res.data
                        this.model_list = official_models || []
                        this.model_list.forEach(item => {
                            if (item.model == this.current_model.model) {
                                this.current_model = {
                                    ...this.current_model,
                                    free_to_use: item.free_to_use,
                                }
                            }
                            if (item.model == this.default_model.model) {
                                this.default_model = {
                                    ...this.default_model,
                                    free_to_use: item.free_to_use,
                                }
                            }
                        })
                        resolve(this.current_model)
                    }
                })
            })
        },

        changeCurrentModelAlertState(model, need_credit_alert = false) {
            if (!model.model) return
            if (model?.model == this.current_model?.model) {
                this.current_model = {
                    ...this.current_model,
                    need_credit_alert
                }
            }
            if (model?.model == this.default_model?.model) {
                this.default_model = {
                    ...this.default_model,
                    need_credit_alert
                }
            }
            if (model?.model == this.similar_mode_model?.model) {
                this.similar_mode_model = {
                    ...this.similar_mode_model,
                    need_credit_alert
                }
            }
            this.lora_model_list?.some(item => {
                if (model?.model == item.model) {
                    Object.assign(item, {
                        need_credit_alert
                    })
                    return true
                }
            })
            this.model_list?.some(item => {
                if (model?.model == item.model) {
                    Object.assign(item, {
                        need_credit_alert
                    })
                    return true
                }
            })

        },

        // 切换当前模型
        updateCurrentModel(model) {
            return new Promise((resolve) => {
                const createLayoutStore = useCreateLayoutStore();
                // 上报
                reportSelectModel(
                    {
                        model: model.model
                    }
                ).then(res => {
                    if (res.code == 200) {
                        firebaseUtils.logCustomEvent("create_model_list_click", {
                            source: this.current_model.model + ',' + model.model,
                            tab_stare: createLayoutStore.createEditMode == 'easy' ? 'basic' : 'advanced'
                        });
                        this.current_model = model
                        // this.changeCurrentModelAlertState()
                        this.choose_model_data = {
                            show_choose_model: false,
                            is_show: false
                        }
                        resolve()
                    }
                })
            })
        },

        // 获取训练模型id
        getLoraId() {
            return new Promise((resolve, reject) => {
                queryLoraTaskProcess({}).then(res => {
                    if (res.code == 200) {
                        this.lora_id = res.data?.id
                        this.lora_state = res.data?.state
                        this.show_modle = res.data?.model
                        this.wait_num = res?.data?.wait_num || 0
                        this.model_name = res.data?.model?.display_name
                        if ([1, 2].includes(res.data?.state)) {
                            this.getModelProgress()
                        }
                        resolve()
                    } else {
                        reject()
                    }
                }).catch(() => {
                    reject()
                })
            })
        },

        // 新增上传文件列表
        addFileList(item) {
            this.uploadList.unshift(item)
        },

        // 更新上传文件列表状态
        updateFileList(uuid, item) {
            let index = this.uploadList.findIndex(
                (itemF) => itemF.uuid === uuid
            );
            if (index > -1) {
                Object.assign(this.uploadList[index], item);
            }
        },

        init() {
            this.loraRnderData.isLoading = true;
            const combinedArray = this.loraUploadList.concat(this.uploadList);
            const ids = [...new Set(combinedArray.map(item => item.id).filter(id => id !== undefined))];
            this.upload_ids = ids
            getUploadList({
                size: 30,
                task_id: this.lora_id,
                ids
            }).then((res) => {
                if (res.code == "200") {
                    this.loraRnderData.isLoading = false;
                    this.loraRnderData.loadError = false;
                    const { data } = res;
                    if (!data.files) {
                        this.loraRnderData.finished = true;
                        this.loraUploadList = []
                    } else {
                        this.loraUploadList = data.files;
                        this.loraRnderData.finished = false;
                    }
                    this.total = data.total || 0;
                    this.show_total = data.total || 0
                } else {
                    this.loraRnderData.isLoading = false;
                    this.loraRnderData.loadError = true;
                }
            }).finally(() => {
            });
        },

        doLoadMore(done) {
            this.loraRnderData.isLoading = true
            const combinedArray = this.loraUploadList.concat(this.uploadList);
            const ids = [...new Set(combinedArray.map(item => item.id).filter(id => id !== undefined))];
            this.upload_ids = ids
            getUploadList({
                size: 30,
                task_id: this.lora_id,
                ids
            })
                .then((res) => {
                    if (res.code == 200) {
                        this.loraRnderData.loadError = false;
                        const { data } = res;
                        if (!data.files) {
                            done && done(this.loraRnderData, true);
                        } else {
                            this.loraUploadList = [...this.loraUploadList, ...data.files];
                            done && done(this.loraRnderData, false);
                        }
                    } else {
                        this.loraRnderData.loadError = true;
                    }
                })
                .finally(() => { });
        },

        // 上传训练素材
        reportUpload(uuid) {
            return new Promise((resolve, reject) => {
                const item = this.uploadList.find(item => item.uuid == uuid)
                if (item) {
                    const { url, name, duration } = item
                    const controller = new AbortController();
                    this.uploadControllers[uuid] = controller;
                    // this.uploadControllers.set(uuid, controller); // 存储 controller
                    addUploads(
                        {
                            task_id: this.lora_id,
                            url,
                            name,
                            duration
                        }, { controller }).then(res => {
                            if (res.code == 200) {
                                resolve(res)
                            } else if (res.code == 6344) {
                                resolve({
                                    code: 6344
                                })
                            }
                            else {
                                resolve({
                                    code: 500
                                })
                            }
                        }).catch(() => {
                            resolve({
                                code: 500
                            })
                        }).finally(() => {
                            delete this.uploadControllers[uuid]
                        })
                }

            })
        },

        // 取消单个请求
        cancelUpload(uuid) {
            const controller = this.uploadControllers[uuid];
            if (controller) {
                controller.abort(); // 取消请求
                delete this.uploadControllers[uuid]
                console.log(`请求 ${uuid} 已取消`);
            } else {
                console.log(`未找到请求 ${uuid}`);
            }
        },

        // 删除上传文件
        deleteUploadItem(uuid, callBack) {
            let index = this.uploadList.findIndex(
                (itemF) => itemF.uuid === uuid
            );
            if (index > -1) {
                const id = this.uploadList[index]?.id
                this.upload_ids = this.upload_ids.filter(cid => cid !== id);
                if (id) {
                    delUploads({
                        id,
                        task_id: this.lora_id
                    }).then(res => {
                        if (res.code == 200) {
                            this.uploadList.splice(index, 1)
                        }
                    })
                    this.show_total--
                    if (this.show_total > 30 && this.uploadList.length + this.loraUploadList.length < 30) {
                        callBack?.();
                    }
                }
                else {
                    this.cancelUpload(uuid)
                    this.uploadList.splice(index, 1)
                }
            }
        },


        deleteItem(uuid) {
            let index = this.uploadList.findIndex(
                (itemF) => itemF.uuid === uuid
            );
            if (index > -1) {
                this.uploadList.splice(index, 1)
            }
        },

        // 重试
        retryUploadItem(uuid) {
            return new Promise((resolve) => {
                let item = this.uploadList.find(
                    (itemF) => itemF.uuid === uuid
                );
                resolve(item)
            })

        },

        // 删除已保存文件列表
        deleteUploadSavedItem(id, callBack) {
            delUploads({
                id,
                task_id: this.lora_id
            }).then(res => {
                if (res.code == 200) {
                    let index = this.loraUploadList.findIndex(
                        (itemF) => itemF.id === id
                    );
                    if (index > -1) {
                        this.upload_ids = this.upload_ids.filter(cid => cid !== id);
                        this.loraUploadList.splice(index, 1)
                        this.show_total--
                        if (this.show_total > 30 && this.uploadList.length + this.loraUploadList.length < 30) {
                            callBack()
                        }
                    }
                }
            })
        },

        // 创建模型
        createModel() {
            const createLayoutStore = useCreateLayoutStore();
            return new Promise((resolve, reject) => {
                createLora(
                    {
                        id: this.lora_id,
                        model: this.model_name,
                        source: createLayoutStore.createEditMode == 'easy' ? 'basic' : 'advanced'
                    }
                ).then(res => {
                    if (res.code == 200) {
                        this.lora_state = res.data?.state
                        this.wait_num = res.data?.wait_num || 0
                        this.show_modle = res.data?.model
                        // 开始轮询
                        this.getModelProgress()
                        resolve()
                    } else {
                        const pinia = getActivePinia()
                        const { $$t } = pinia?.$i18n ?? {}
                        if (res.code == 6316) {
                            message.error({
                                position: "top",
                                content: $$t("create.nameInvalid"),
                            })
                        }
                        reject(res)
                    }
                }).catch(() => {
                    reject()
                })
            })
        },

        // 保存模型name
        saveModelName() {
            updateLoraTask({
                id: this.lora_id,
                model_name: this.model_name
            }).then(res => {
                if (res.code == 6316) {
                    const pinia = getActivePinia()
                    const { $$t } = pinia?.$i18n ?? {}
                    message.error({
                        position: "top",
                        content: $$t("create.nameInvalid"),
                    })
                }
            })
        },

        getModelProgress() {
            const interval = 20000; // 20 seconds
            const allowedStates = [3, 4, 6, 7];
            const intervalId = setInterval(() => {
                getLoraTaskState({
                    id: this.lora_id
                }).then(res => {
                    if (res.code == 200) {
                        this.lora_state = res?.data?.state
                        if (allowedStates.includes(res?.data?.state)) {
                            clearInterval(intervalId);
                            if (res?.data?.state == 3) {
                                this.updateLoraList(this.show_modle)
                            }
                        } else if (res?.data?.state == 1) {
                            this.wait_num = res?.data?.wait_num || 0
                        } else if (res?.data?.state == 2) {
                            this.generating_progress = res?.data?.process || 0
                        }
                    }
                })
            }, interval);
        },

        // 更新lora列表
        updateLoraList(item) {
            let index = this.lora_model_list.findIndex(
                (itemF) => itemF.model === item.model
            );
            if (index == -1) {
                this.lora_model_list.push(item)
            }
        },

        // 取消失败任务
        cancelFailLora() {
            return new Promise((resolve) => {
                cancelLoraTask(
                    {
                        id: this.lora_id
                    }
                ).then(res => {
                    if (res.code == 200) {
                        // this.loraUploadList = [],
                        this.uploadList = []
                        this.lora_state = 7
                        this.getLoraId()
                        this.init()
                        resolve()
                    }
                })
            })

        },

        // 重置
        resetModel() {
            this.lora_id = 0
            this.lora_state = 0
            this.loraUploadList = []
            this.uploadList = []
            this.upload_ids = []
        },

        // 重置免费状态
        changeFreeState(model) {
            if (!model.model) return
            model.free_to_use = Math.max(0, model.free_to_use - 1)
            if (model?.model == this.current_model?.model) {
                this.current_model = {
                    ...this.current_model,
                    free_to_use: model.free_to_use
                }
            }
            if (model?.model == this.default_model?.model) {
                this.default_model = {
                    ...this.default_model,
                    free_to_use: model.free_to_use
                }
            }
            if (model?.model == this.similar_mode_model?.model) {
                this.similar_mode_model = {
                    ...this.similar_mode_model,
                    free_to_use: model.free_to_use
                }
            }
            this.lora_model_list?.some(item => {
                if (model?.model == item.model) {
                    Object.assign(item, {
                        free_to_use: model.free_to_use
                    })
                    return true
                }
            })
            this.model_list?.some(item => {
                if (model?.model == item.model) {
                    Object.assign(item, {
                        free_to_use: model.free_to_use
                    })
                    return true
                }

            })
        },
        setSimilarModeModel(model) {
            if (!model.model) return;
            this.similar_mode_model = model
            this.model_list?.some(item => {
                if (model?.model == item.model) {
                    Object.assign(model, {
                        need_credit_alert: item.need_credit_alert,
                        free_to_use: item.free_to_use
                    })
                    return true
                }
            })
        }
    }
})

export default useModelData;